<!-- 绑定邮箱 -->
<template>
  <div class="container containerBox">
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      class="change-from"
      :rules="rules"
    >
        <div class="container-title">绑定邮箱</div>
      <el-form-item label="邮箱" prop="email">
        <el-input  v-model="form.email"></el-input>
      </el-form-item>
	  <el-form-item>
	    <el-button
	      type="primary"
	      @click="onSubmitCode"
	    >获取验证码</el-button>
	  </el-form-item>
      <el-form-item label="验证码" prop="captcha_code">
        <el-input  v-model="form.captcha_code"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
        >确认</el-button>
		<el-button
		  type="primary"
		  @click="onSubmitdel"
		>解除绑定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'
const jsSHA = require("jssha");
import {checkEmail } from '@/utils/validator'
import stringUtils from '@/utils/stringUtils'

export default {
    name: "changepassword",
    inject: ["reload"],
    data() {
        return {
            form: {
				email:'',
				captcha_code:''
			},
            rules: {
                email: [
                    { required: true, trigger: 'blur',validator: checkEmail },
                ],
                captcha_code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ]
            }
        };
    },
    computed: {
        // 项目列表
        ...mapGetters(["user"])
    },
	created() {
		this.getuserinfo()
	},
    methods: {
		async getuserinfo(){
			let res = await Service.userInfo();
			this.form.email = res.email
		},
		async onSubmitCode(){
			if(this.form.email){
				if (stringUtils(this.form.email).isEmail()) {
				    let res = await Service.getEmailcode(this.form);
					if(res){
						this.$message({
						    type: 'success',
						    message: '验证码已发送到您的邮箱，请注意查收!'
						});
					}
				} else {
				    return callback(new Error("电子邮箱格式有误"));
				}
			}else{
				this.$message({
				    type: 'warning',
				    message: '请输入电子邮箱!'
				});
			}
		},
        onSubmit() {
            this.$refs["form"].validate(async (valid) => {
                if (valid) {
                    let res = await Service.bindEmail(this.form);
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '绑定成功!'
                        });
						this.reload()
                    }
                } else {
                    return false;
                }
            });
        },
		async onSubmitdel(){
			let res = await Service.unbindEmail({});
			if(res){
				this.$message({
				    type: 'success',
				    message: '解绑成功!'
				});
			}else{
				
			}
		}
    }
};
</script>
<style lang='css' scoped>
.change-from{
    width: 500px;
    margin: 0 auto ;
}
</style>